<template>
    <div
            id="data-tables"
            tag="section"
    >
        <!--
        <base-v-component-mod
          :heading="test.test"
          link=""
        />

        <base-button
          text
          small
          @click="$router.push('/lessons/' + test.idlesson + '/tests')"
        >
          <v-icon left>
            mdi-arrow-left
          </v-icon> Назад к урокам
        </base-button>
    -->
        <component
                :is="testname"
                :idtest="idtest"
                :points="points"
                :lesson="lesson"
                :testsCount="testsCount"
                :key="idtest"
                :showButtons="showButtons"
                :testmode="test.testmode"
                @correctAnswer="correctAnswer"
                @wrongAnswer="wrongAnswer"
                @testComplete="testComplete"
        />
    </div>
</template>

<script>
    /*
      *1.  'Vocab Game. Перетаскивание картинок к словам' },
      *2,  'Right word. Выбрать правильное слово по вопросу-картинке' },

      *3,  'Mixed pictures. Перепривязать слова к правильным картинкам (перетаскивание)' }, Сложно - как освобождать дропзону?
      *4,  'Guessing. Выбрать правильное слово по вопросу-картинке. Картинка открывается по частям.' }, Накладывание элементов в vuetify. zindex?
      *5,  'Memory game. Найти пару картинка - слово. (игра pairs)' },  Есть пример на vuexamples
      *6,  'Make the sentence. Составить предложение по картинке-заданию' }, Легко
      *7,  'Find the picture. Выбрать картинку-ответ по заданию - слову' }, Легко
      *8,  'Keyboard. Набрать на вирт. клавиатуре слово по заданию-картинке' }, не сложно
      *9,  'Describer. Выбрать правильную картинку по вопросу-предложению' }, легко
     //10, 'Draw lines. Протянуть линию от картинок к словам' },  Изучить как рисовать линии
    */

    // @ is an alias to /src
    import api from '@/utils/api'
    import test1 from '@/views/tests/Test1.vue'
    import test2 from '@/views/tests/Test2.vue'
    import test3 from '@/views/tests/Test3.vue'
    import test4 from '@/views/tests/Test4.vue'
    import test5 from '@/views/tests/Test5.vue'
    import test6 from '@/views/tests/Test6.vue'
    import test7 from '@/views/tests/Test7.vue'
    import test8 from '@/views/tests/Test8.vue'
    import test9 from '@/views/tests/Test9.vue'
    import test10 from '@/views/tests/Test10.vue'
    import test11 from '@/views/tests/Test11.vue'
    import test12 from '@/views/tests/Test12.vue'
    import test13 from '@/views/tests/Test13.vue'
    import test14 from '@/views/tests/Test14.vue'
    import test16 from '@/views/tests/Test16.vue'
    import test17 from '@/views/tests/Test17.vue'
    import test21 from '@/views/tests/Test21.vue'
    import test22 from '@/views/tests/Test22.vue'
    import test23 from '@/views/tests/Test23.vue'
    import test24 from '@/views/tests/Test24.vue'
    import test31 from '@/views/tests/Test31.vue'
    import test32 from '@/views/tests/Test32.vue'
    import test33 from '@/views/tests/Test33.vue'
    import test34 from '@/views/tests/Test34.vue'
    import test41 from '@/views/tests/Test41.vue'
    import test42 from '@/views/tests/Test42.vue'

    export default {
        name: 'Testpreview',
        components: {
            test1,
            test2,
            test3,
            test4,
            test5,
            test6,
            test7,
            test8,
            test9,
            test10,
            test11,
            test12,
            test13,
            test14,
            test16,
            test17,
            test21,
            test22,
            test23,
            test24,
            test31,
            test32,
            test33,
            test34,
            test41,
            test42,
        },
        props: {
            idtest: {default: null},
            points: {default: null},
            lesson: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
        },
        data: () => ({
            testname: 'span',
            test: {},
        }),

        mounted() {
            api({url: '/tests/' + this.idtest}).then(response => {
                this.test = response.data
                // if (this.test.idtesttype < 14)
                this.testname = 'test' + this.test.idtesttype
            })
        },

        methods: {
            correctAnswer() {
                this.$emit('correctAnswer')
            },
            wrongAnswer(params) {
                this.$emit('wrongAnswer', params)
            },
            testComplete() {
                this.$emit('testComplete')
            },
        }

    }
</script>
